import React from "react";
const WebProducts = () => {
  return (
    <div>
      <h1>Product List</h1>
    </div>
  );
};

export default WebProducts;
